import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-voter-print',
  templateUrl: './voter-print.component.html',
  styleUrls: ['./voter-print.component.scss']
})
export class VoterPrintComponent implements OnInit {
  _data:any;
  localData:{
    fname:string,
    mname:string,
    lname:string
  };
  test:any = "test111111";
  SrNo:any = "sr1"

  @Input()
  get selectedVisitorToPrint(): any {
    return this._data;
  }
  set selectedVisitorToPrint(value: any) { 
    // console.log("value",value);
       
    this._data = value;
    // console.log("dataa",this._data.firstName);
    
  }


  constructor() {
   }

  ngOnInit() {
    this.test = this._data.firstName;
  }

}
